<!-- components/EditForm.vue -->
<template>
    <div class="vip_div" :style="{ height: screenHeight + 'px' }">
        <div class="wai_div">
            <CardShowVip :DataArray="DataArray" :IsShowEvent="IsShowEvent" :EventData="EventData"></CardShowVip>
        </div>
        <div class="equities_vip_div">
            <CardEquitiesShow :EquitiesData="EquitiesDatas"></CardEquitiesShow>
        </div>
        <div class="qr_code_div">
            <div class="qr_code_div_item_div">
                <div>客服二维码</div>
                <img :src="kefuQRs" class="qr_code">
            </div>
            <div class="qr_code_div_item_div">{{ qr_code_text }}</div>
        </div>
        <div>
            <el-input v-model="input_order" :placeholder="orderNumbermessage" :disabled="OrderDis">
                <template #prepend>
                    <div>订单号：</div>
                </template>
                <template #append>
                    <el-button @click="VerifyOrder" :disabled="OrderInputButtonDis">{{ OrderInputButtonText
                    }}</el-button>
                </template>
            </el-input>
        </div>
        <div class="order_state_div">
            <div>订单状态：</div>
            <div class="order_state_show"
                :class="order == 0 ? 'order_text_wsr' : order == 1 ? 'order_text_djh' : 'order_text_jh'"
                id="ActivationStatusCodeDiv">{{ OrderState }}</div>
        </div>
        <div>{{ Authorization }}</div>
        <div>
            <el-input v-model="input_authorization" :placeholder="licenseKeymessage" :disabled="AuthorizationDis">
                <template #prepend>
                    <div>授权码：</div>
                </template>
                <template #append>
                    <el-button @click="VerifyAuthorization" :disabled="AuthorizationInputButtonDis">{{
                        AuthorizationInputButtonText }}</el-button>
                </template>
            </el-input>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request' // 就写这一行
import { VipShowData, EventShowData, isShowEvent, kefuQR } from './VipShowData';
import { EquitiesData, QrCodeText, Authorization_text } from './VipShowData';


export default {
    name: 'ShopVIP',
    props: {},
    data() {
        return {
            orderNumbermessage: '请输入客服给你的36位订单号',
            licenseKeymessage: '请输入客服给你的授权码',
            DataArray: VipShowData,
            IsShowEvent: isShowEvent,
            EventData: EventShowData,
            EquitiesDatas: EquitiesData,
            qr_code_text: QrCodeText,
            OrderDis: false,
            OrderInputButtonText: "验证",
            input_order: "",
            OrderState: "未输入",  // ["未输入", "待激活", "待支付", "已激活", "激活失败"]
            Authorization: Authorization_text,
            input_authorization: "",
            AuthorizationDis: true,
            AuthorizationInputButtonText: "授权",
            OrderInputButtonDis: false,
            AuthorizationInputButtonDis: true,
            order: 0,  // [0: 灰色代表未输入, 1: 红色代表待激活待支付激活失败, 2: 绿色代表已激活]
            screenHeight: 0, // 新增：用于存储屏幕高度
            pollingTimer: null, // 新增：用于存储定时器ID，方便清除
            maxPollingTime: 480000, // 新增：最大轮询时间（例如60秒），防止用户一直傻等
            kefuQRs: kefuQR
        }
    },
    methods: {
        async VerifyOrder() {
            if (this.input_order.replace(/\s/g, '') == "") {
                this.$messageX.xiaoxiti("e", "请先输入客服给你的订单号");
                return;
            }
            if (this.OrderInputButtonText === "验证") {
                this.OrderDis = true;
                this.OrderInputButtonText = "清除";
                this.OrderState = "待激活";
                this.order = 1;
                // 后端掉用激活订单  激活之后进行轮询直到后端返回状态为true时更改前端订单状态为已激活
                try {
                    const res = await request.post('/QrCodeVerify', {
                        qrCodeText: this.input_order
                    });

                    this.$messageX.xiaoxiti("c", res.message);
                    this.OrderInputButtonDis = true;
                    if (res.response.Orderstate == '已支付') {
                        this.OrderState = '查询中...';
                    } else {
                        this.OrderState = '支付中';
                    }

                    this.startPolling();

                } catch (err) {
                    console.log('订单验证失败:', err);
                    this.$messageX.xiaoxiti("e", err.message || "查询服务异常");
                    this.OrderInputButtonDis = false;
                    this.OrderState = '支付失败';
                    this.order = 1;

                }

            } else {
                this.OrderDis = false;
                this.OrderInputButtonText = "验证";
                this.input_order = "";
                this.OrderState = "未输入";
                this.order = 0;
            }

        },
        async VerifyAuthorization() {
            if (this.input_authorization.replace(/\s/g, '') == "") {
                this.$messageX.xiaoxiti("e", "请先输入客服给你的授权码");
                return;
            }
            if (this.AuthorizationInputButtonText === "授权") {
                this.AuthorizationDis = true;
                this.AuthorizationInputButtonText = "重新授权";
                this.AuthorizationInputButtonDis = true;
                // 调用后端成功授权之后重定向界面，刷新前端的缓存
                // 调用后将AuthorizationInputButtonDis=false
                // 后端掉用激活订单  激活之后进行轮询直到后端返回状态为true时更改前端订单状态为已激活
                try {
                    const res = await request.post('/VerifyModify', {
                        OrderID: this.input_order,
                        LicenseKey: this.input_authorization
                    });

                    this.$messageX.xiaoxiti("c", res.message);
                    var q = confirm("检测到账号数据有更新！请重新登录账号！");
                    if (q) {
                        var storedData = JSON.parse(localStorage.getItem('userData'));
                        var userName = storedData.user.user.Accounts;
                        localStorage.clear();
                        localStorage.setItem("vipUpdata", userName);
                        location.reload();
                    } else {
                        localStorage.clear();
                        location.reload();
                    }


                } catch (err) {
                    console.log('订单授权失败:', err);
                    this.$messageX.xiaoxiti("e", err.message || "查询服务异常");
                    this.AuthorizationInputButtonDis = false;
                    this.OrderState = '授权失败';
                    this.order = 1;
                }
            } else {
                this.AuthorizationDis = false;
                this.AuthorizationInputButtonText = "授权";
                this.input_authorization = "";
            }

        },
        startPolling() {
            if (this.pollingTimer) {
                clearInterval(this.pollingTimer);
            }
            let startTime = Date.now();
            this.pollingTimer = setInterval(async () => {
                // 检查是否超时（可选，比如超过60秒自动停止）
                if (Date.now() - startTime > this.maxPollingTime) {
                    this.stopPolling();
                    this.$messageX.xiaoxiti("w", "查询超时，请刷新页面或联系客服");
                    this.OrderInputButtonDis = false;
                    return;
                }

                try {
                    // 调用刚才写的后端新接口
                    const res = await request.post('/CheckOrderStatus', {
                        qrCodeText: this.input_order
                    });

                    if (res.success) {
                        // 如果后端返回已支付
                        if (res.isPaid === true) {
                            this.stopPolling(); // 停止轮询

                            // --- 更新前端状态 ---
                            this.OrderState = "已激活";
                            this.order = 2; // 绿色状态
                            this.AuthorizationDis = false; // 解锁授权码输入框
                            this.AuthorizationInputButtonDis = false;

                            this.$messageX.xiaoxiti("c", "订单已支付，请输入授权码激活！");
                        }
                        // 如果未支付，什么都不做，等待下一次轮询
                    }
                } catch (error) {
                    console.error("轮询出错", error);
                    this.OrderInputButtonDis = false;
                    this.stopPolling(); // 停止轮询
                    if (error.response.data.message) {
                        this.$messageX.xiaoxiti("e", error.response.data.message);
                    } else {
                        this.$messageX.xiaoxiti("e", error.message);
                    }
                    this.OrderState = '查询失败';
                    this.order = 1;
                }

            }, 2000); // 每 2000 毫秒（2秒）查询一次
        },
        stopPolling() {
            if (this.pollingTimer) {
                clearInterval(this.pollingTimer);
                this.pollingTimer = null;
            }
        }

    },
    beforeUnmount() {
        if (this.pollingTimer) {
            clearInterval(this.pollingTimer);
            this.pollingTimer = null;
        }
    },
    mounted() {
        this.screenHeight = window.innerHeight - 72;
        document.getElementsByClassName("modal-container")[0].style.height = "100%";
        document.getElementsByClassName("modal-container")[0].style.width = "100%";
    }
}
</script>

<style scoped>
.vip_div {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-evenly;
    align-items: center;
    position: relative;
    width: 100%;
    overflow-y: auto;
}

.wai_div {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-evenly;
}

.equities_vip_div {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-evenly;
    align-items: center;
    height: 200px;
    padding: 10px;
}

.qr_code_div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 250px;
}

.qr_code_div_item_div {
    width: 50%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.order_text_wsr {
    color: rgb(118, 118, 118);
}

.order_text_djh {
    color: rgb(255, 0, 0);
}

.order_text_jh {
    color: rgb(4, 215, 78);
}

.qr_code {
    width: 160px;
}

.order_state_div {
    display: flex;
    margin: 10px 0px 10px 0px;
    width: 50%;
    flex-direction: row;
    justify-content: space-evenly;
    align-content: center;
    align-items: center;
}

.order_state_show {
    border: 1px solid rgba(0, 0, 0, 1);
    padding: 0px 10px 00px 10px;
    border-radius: 15px;
}
</style>